module.exports = __webpack_public_path__ + "static/media/ios-add-circle-outline.e3a9f2f6.svg";